import React from "react";
import Divider from "@mui/material/Divider";
import {
  ProductWrapper,
  ProductData,
  ProductImage,
  ProductDataInfo,
} from '../styles';

const CartProduct = ({...props}) => {
  return (
    <React.Fragment>
      <ProductWrapper key={props.item.id}>
        <ProductImage src={props.item.image}/>
        <ProductDataInfo>
          <ProductData>
            <h4>{props.item.title}</h4>
            <p>Quantity: {props.item.quantity}</p>
            <p>Price: {props.item.price} CHF</p>
            <p>Total: {props.item.sum.toFixed(2)} CHF</p>
          </ProductData>
        </ProductDataInfo>
      </ProductWrapper>
      <Divider />
    </React.Fragment>
  );
};

export default CartProduct;
